import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component({
  mixins: [style],
})
export default class AssembleLink extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '拼团列表';

  width = '800px';

  cancelText = '关闭';

  mounted() {
    this.getAssembleList();
  }

  getAssembleList() {
    const postParams = {
      page: this.page,
      ptState: 1,
      activityState: 4,
      keyword: this.keyword,
      pageSize: this.pageSize,
      siteCodes: this.siteCodes,
    };
    IPSService.assembleActList({ postParams }).then((response) => {
      this.total = response.count;
      const result = response.list;
      // 格式化数据
      result.forEach((element) => {
        element.actBeginTime = Functions.timeFormatSec(element.actBeginTime);
        element.actEndTime = Functions.timeFormatSec(element.actEndTime);
        element.addTime = Functions.timeFormatSec(element.addTime);
        element.time = `${element.actBeginTime}~${element.actEndTime}`;
      });
      this.dataList = result;
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getAssembleList();
  }

  onPageChange(val) {
    this.page = val;
    this.getAssembleList();
  }

  onSelect(ptId, ptName) {
    this.$emit('result', { id: ptId, name: ptName });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getAssembleList();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="团购ID/团购标题"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="55" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ptId" label="团购ID" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ptName" label="团购标题" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="time" label="活动期间" width="320" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="操作"
            width="80px"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.ptId, scope.row.ptName)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
